module.exports = __webpack_public_path__ + "static/media/BS_F_Fashion_Sempione.fe715c80.png";